var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import "../../components/header";
import "../../components/leftMenu";
import "./dailyFlock.css";
import "../../components/paging";
import * as authorization from "../../lib/authorization";
import * as ajax from "../../app-lib/ajax_proxy";
import "../../components/tree";
import page from 'page';
var HeaderModel = /** @class */ (function (_super) {
    __extends(HeaderModel, _super);
    function HeaderModel(root) {
        var _this = _super.call(this, '/api/group', root, {}) || this;
        _this.depaId = ko.observable();
        _this.searchName = ko.observable('');
        //isShowCheckbox=ko.observable();
        _this.Qid = ko.observable();
        _this.departmentUrl = ko.observable();
        _this.DepartmentUserList = ko.observableArray([]);
        return _this;
    }
    HeaderModel.prototype.set = function () {
        if (!this.viewModel().data.name) {
            return window.popBox.show('群名称不能为空');
        }
        if (this.viewModel().data.name.length > 20) {
            return window.popBox.show('群名称过长');
        }
        if (this.viewModel().data.said == null || this.viewModel().data.said.trim() == '') {
            //  return window.popBox.show('群备注不能为空')
        }
        else {
            if (this.viewModel().data.said.length > 1000) {
                return window.popBox.show('群备注不能超过1000个字符');
            }
        }
        if (this.viewModel().data.user().length == 0) {
            return window.popBox.show('群人员不能为空');
        }
        if (this.Qid() != undefined) {
            ajax.put('/api/group', {
                data: this.toJS(this.viewModel().data)
            }).then(function (n) {
                if (n.message == '群名重复') {
                    return window.popBox.show(n.message);
                }
                window.popBox.show(n.message).then(function () {
                    page('/file/daily');
                });
            });
        }
        else {
            this.saveData(this.viewModel().data).then(function (n) {
                if (n.status == '0') {
                    if (n.message == '群名重复') {
                        return window.popBox.show(n.message);
                    }
                    window.popBox.show(n.message).then(function () {
                        page('/file/daily');
                    });
                }
            });
        }
    };
    HeaderModel.prototype.onOrgChange = function (org) {
        var _this = this;
        this.depaId(org.id);
        ajax.get('/api/org/showuser2', { departmentId: org.id })
            .then(function (d) {
            d.data.forEach(function (n) {
                if (_this.isChecked2(_this.viewModel().data.user(), n.id)) {
                    n.isCheck = ko.observable(true);
                }
                else {
                    n.isCheck = ko.observable(false);
                }
            });
            _this.DepartmentUserList(d.data);
            console.log(_this.DepartmentUserList());
        });
    };
    HeaderModel.prototype.checkPerson = function (data, index) {
        if (data.isCheck()) {
            if (!this.isChecked2(this.viewModel().data.user(), data.id)) {
                this.viewModel().data.user.push({
                    userId: data.id,
                    userName: data.name,
                    userType: ko.observable('0'),
                    isCheck: ko.observable(true)
                });
            }
            console.log(this.viewModel().data.user());
        }
        else {
            if (this.isChecked2(this.viewModel().data.user(), data.id)) {
                var index_1 = this.viewModel().data.user().findIndex(function (n) { return n.userId == data.id; });
                this.viewModel().data.user().splice(index_1, 1);
                this.viewModel().data.user(this.viewModel().data.user());
            }
        }
        return true;
    };
    HeaderModel.prototype.checkUser = function (data, index) {
        if (data.isCheck() == false) {
            this.viewModel().data.user().splice(index, 1);
            this.viewModel().data.user(this.viewModel().data.user());
            if (this.isChecked(this.DepartmentUserList(), data.userId)) {
                var index_2 = this.DepartmentUserList().findIndex(function (n) { return n.id == data.userId; });
                this.DepartmentUserList()[index_2].isCheck(false);
            }
        }
        return true;
    };
    HeaderModel.prototype.search = function () {
        var _this = this;
        if (this.depaId() == undefined) {
            return window.popBox.show('未选中部门');
        }
        ajax.get('/api/group/finduser', {
            userName: this.searchName(),
            departmentId: this.depaId()
        }).then(function (d) {
            d.data.forEach(function (n) {
                if (_this.isChecked2(_this.viewModel().data.user(), n.id)) {
                    n.isCheck = ko.observable(true);
                }
                else {
                    n.isCheck = ko.observable(false);
                }
            });
            _this.DepartmentUserList(d.data);
        });
    };
    HeaderModel.prototype.changeType = function (type) {
        if (type() == '0') {
            type('1');
        }
        else {
            type('0');
        }
    };
    //检查已选人员 跟人员库是否对应
    HeaderModel.prototype.isChecked = function (arr, id) {
        for (var i in arr) {
            if (arr[i].id == id) {
                return true;
            }
        }
        return false;
    };
    //检查人员库 跟已选人员是否对应
    HeaderModel.prototype.isChecked2 = function (arr, id) {
        for (var i in arr) {
            if (arr[i].userId == id) {
                return true;
            }
        }
        return false;
    };
    HeaderModel.prototype.reset = function () {
        this.searchName('');
        this.departmentUrl('/api/org/showdepa');
        // this.isShowCheckbox(true);
        this.Qid(undefined);
        this.depaId(undefined);
        this.DepartmentUserList([]);
    };
    HeaderModel.prototype.onViewModelSetting = function (d) {
        d.data.user = ko.observableArray(d.data.user);
        d.data.user().forEach(function (n) {
            n.isCheck = ko.observable(true);
            n.userType = ko.observable(n.userType);
        });
        console.log(d.data.user());
        return Promise.resolve(false);
    };
    return HeaderModel;
}(KnockoutModel));
var mModel = /** @class */ (function (_super) {
    __extends(mModel, _super);
    function mModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    mModel.prototype.init = function () {
        this.hm = new HeaderModel(this.container);
    };
    mModel.prototype.update = function (arg) {
        this.hm.reset();
        this.hm.id = arg.routeData.id;
        if (arg.routeData.id && arg.routeData.id != '00000000-0000-0000-0000-000000000000') {
            //  this.hm.data.id=arg.routeData.query.id
            this.hm.Qid(arg.routeData.id);
        }
        else {
            this.hm.Qid(undefined);
        }
        this.hm.data.userId = authorization.getUserId();
        return this.hm.loadData();
    };
    mModel.prototype.onPause = function () {
        this.hm.viewModel(undefined);
    };
    mModel.prototype.onInitComplete = function () {
        // 兼容ie数组没有findIndex方法
        if (!Array.prototype.findIndex) {
            Object.defineProperty(Array.prototype, 'findIndex', {
                value: function (predicate) {
                    // 1. Let O be ? ToObject(this value).
                    if (this == null) {
                        throw new TypeError('"this" is null or not defined');
                    }
                    var o = Object(this);
                    // 2. Let len be ? ToLength(? Get(O, "length")).
                    var len = o.length >>> 0;
                    // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                    if (typeof predicate !== 'function') {
                        throw new TypeError('predicate must be a function');
                    }
                    // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                    var thisArg = arguments[1];
                    // 5. Let k be 0.
                    var k = 0;
                    // 6. Repeat, while k < len
                    while (k < len) {
                        // a. Let Pk be ! ToString(k).
                        // b. Let kValue be ? Get(O, Pk).
                        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                        // d. If testResult is true, return k.
                        var kValue = o[k];
                        if (predicate.call(thisArg, kValue, k, o)) {
                            return k;
                        }
                        // e. Increase k by 1.
                        k++;
                    }
                    // 7. Return -1.
                    return -1;
                }
            });
        }
    };
    return mModel;
}(Page));
export default mModel;
